function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "ic_cart");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Dsk_Accts_dash_menu_1.8_shop_for_PDP",
  transform: "translate(-1019.000000, -52.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(-21.000000, -4.000000)"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("g", {
  id: "Group-29"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(1007.000000, 56.000000)"
}, React.createElement("g", {
  id: "ic_cart",
  transform: "translate(33.000000, 0.000000)"
}, React.createElement("path", {
  d: "M6,16 C4.9,16 4.01,16.9 4.01,18 C4.01,19.1 4.9,20 6,20 C7.1,20 8,19.1 8,18 C8,16.9 7.1,16 6,16 L6,16 Z M0,0 L0,2 L2,2 L5.6,9.59 L4.25,12.04 C4.09,12.32 4,12.65 4,13 C4,14.1 4.9,15 6,15 L18,15 L18,13 L6.42,13 C6.28,13 6.17,12.89 6.17,12.75 L6.2,12.63 L7.1,11 L14.55,11 C15.3,11 15.96,10.59 16.3,9.97 L19.88,3.48 C19.96,3.34 20,3.17 20,3 C20,2.45 19.55,2 19,2 L4.21,2 L3.27,0 L4.88498131e-15,0 L0,0 Z M16,16 C14.9,16 14.01,16.9 14.01,18 C14.01,19.1 14.9,20 16,20 C17.1,20 18,19.1 18,18 C18,16.9 17.1,16 16,16 L16,16 Z"
}))))))));

var SvgCartIcon = function SvgCartIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCartIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart-icon.8ad462d7.svg";
export { ForwardRef as ReactComponent };